import React, { useMemo } from "react";

import { IgCustomTheme } from "@intelligems/ig-theme";
import { WidgetDeviceType, WidgetRenderLocation } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/styles";

interface DeviceWidgetProps {
  device: WidgetDeviceType;
  className?: string;
  children?: React.ReactNode;
  renderLocation?: WidgetRenderLocation;
}

export const DeviceWidget = React.memo((props: DeviceWidgetProps) => {
  const theme = useTheme<IgCustomTheme>();
  const { device, children, renderLocation } = props;

  const padding = useMemo(() => {
    switch (renderLocation) {
      case "settings":
        return "40px 48px 48px 48px";
      case "drawer":
        return "12px";
      case "viewOnly":
        return "40px 16px 40px 16px";
      default:
        return "0px";
    }
  }, [renderLocation]);

  return (
    <Grid
      item
      container
      direction={"row"}
      justifyContent={"center"}
      padding={padding}
      className={"device-widget"}
    >
      {children}
    </Grid>
  );
});
